define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GaFeeStateGov = void 0;
    class GaFeeStateGov extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "GaScheduleId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GaScheduleIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FiscalQtr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FiscalQtrError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeStateGov", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeStateGovError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GaFeeSchedule", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, GaFeeStateGov.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.GaFeeSchedule = parent;
            this.GaScheduleId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.GaFeeSchedule = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.GaScheduleId = (0, EntityUtil_1.toInt)(entity.GaScheduleId);
            a.FiscalQtr = (0, EntityUtil_1.toInt)(entity.FiscalQtr);
            a.StartDt = b.StartDt;
            a.EndDt = b.EndDt;
            a.FeeStateGov = (0, EntityUtil_1.toFloat)(entity.FeeStateGov);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, GaFeeStateGov.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                GaScheduleId: this.GaScheduleId,
                FiscalQtr: this.FiscalQtr,
                StartDt: this.StartDt,
                EndDt: this.EndDt,
                FeeStateGov: this.FeeStateGov,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.GaFeeStateGov = GaFeeStateGov;
    Object.defineProperty(GaFeeStateGov, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "GaFeeStateGov"
    });
    Object.defineProperty(GaFeeStateGov, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Fees Due to State Government"
    });
    Object.defineProperty(GaFeeStateGov, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "GaScheduleId", "FiscalQtr", "StartDt", "EndDt", "FeeStateGov"]
    });
    Object.defineProperty(GaFeeStateGov, "GaScheduleIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeStateGov, "FiscalQtrReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeStateGov, "StartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeStateGov, "EndDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeStateGov, "FeeStateGovReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "GaScheduleId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "GaScheduleIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "FiscalQtr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "FiscalQtrError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "StartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "StartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "EndDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "EndDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "FeeStateGov", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "FeeStateGovError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeStateGov.prototype, "GaFeeSchedule", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], GaFeeStateGov.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GaFeeStateGov.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GaFeeStateGov.prototype, "merge", null);
});
